import React, {useState, useEffect} from "react";
import Paginator from "../../shared/Paginator";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import {formatDateWithTime} from '../../utils/dateFormat'
import API from "../../services/api";
import { parse } from 'papaparse'
import config from "../../config";
import {Toast} from '../../shared/Toast'
import {useForm} from "react-hook-form";
import {useNavigate} from 'react-router-dom'
import { SlButton, SlDrawer   } from '@shoelace-style/shoelace/dist/react';
import { debounce } from "../../utils/Debounce";

function SalesPriceCardList() {
const navigate = useNavigate();
const [data, setData] = useState([]);
const [totalPages, setTotalPages] = useState(0);
const [currentPage, setCurrentPage] = useState(0);
const [search, setSearch] = useState("");
const [loading, setLoading] = useState(false);
const {register, setValue } = useForm();
const [view, setView] = useState(false);
const [duplicateData, setDuplicateData] = useState([]);
const [fileLoader, setFileLoader] = useState(false);
const fileChange = async (e) => {
  const file = e.target.files[0]
  const type = e.target.value.split(".").pop()
  if (type === 'csv') {
    setFileLoader(true)
    const reader = new FileReader();

    reader.onload = async () => {
      const jsonArray = parse(reader.result, { header: true }).data;
      try {
        let res = await API({
          url: `/saleslocation/addLocationPricewithFile`,
          method: "POST",
          responseType: "json",
          data: jsonArray
        });
        if (res.data.length > 0) {
          setView(true)
          setDuplicateData(res.data)
          Toast("success", "Locations Added Successfully with out Duplicates");
          setCurrentPage(0);
          setSearch('');
          loadData(search, 0);
        }
        else if (res?.code === 200) {
          Toast("success", "Locations Added Successfully");
          setCurrentPage(0);
          setSearch('');
          loadData(search, 0);
        } else {
          Toast('error', res?.message);
        }
      } catch (error) {
        let er = error?.response?.message || "Something went wrong"
        Toast("error", er)
        if (error.response.status === 401)
          navigate("/")
      }
      finally{
        setFileLoader(false)
      }
      setValue('file_csv', "")

    };

    reader.readAsText(file);
  } else {
    Toast("error", "Only csv files are allowed")
    setValue("file_csv", "")
  }

}

  const loadData = async (search, page) => {
    setLoading(true);
    try {
      let res = await API({
        url: "/saleslocation/card-list",
        method: "POST",
        responseType: "json",
        data: {
          search,
          page,
          perpage:config.PER_PAGE,
        },
      })
      if (res.code === 200) {
        setData(res.data.data);
        setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      }
    } catch (error) {
        console.error(error);
    }
    finally{
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(search, event.selected)
  
  }
  useEffect(() => {
    loadData(search, currentPage);
  }, [search]);

  return (
    <>
    <div className="flex flex-wrap justify-between items-center my-2">
      <h5>Sales Card List</h5>
      <div className="d-flex gap-3 items-center">
        <input type="text" placeholder="Search" className="form-control" onChange={debounce((e) => setSearch(e.target.value),1000)} />
        <label htmlFor="file" className="m-0">
                  <i className="bi bi-arrow-up-circle ml-3 px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Upload Card Lists"></i>
                  <input type="file" id="file" style={{ display: "none" }} name="file"
                    {...register("file_csv", {
                      required: false,
                      onChange: (e) => fileChange(e),
                    })}
                  />
                </label>
                {fileLoader && <div className="spinner-border text-primary" role="status"  >
            <span className="visually-hidden">Loading...</span>
          </div>}
      </div>
      
    </div>

    <div className='overflow-x-auto mb-4'>
        <table className='table table-bordered'>
          <thead className="sticky top-0">
            <tr>
              <th>Language</th>
              <th>State</th>
              <th>District</th>
              <th>Constituency</th>
              <th>Creative Type</th>
              <th>Page</th>
              <th>Amount</th>
              <th>Created Date</th>
            </tr>
          </thead>
          {(data?.length && !loading) ? (
            <tbody>
              {data.map((item) => {
                return (
                  <tr key={item.id} >
                    <th>{item.language}</th>
                    <td>{item.state || '-'}</td>
                    <td >{item.district || '-'}</td>
                    <td>{item.constituency || '-'}</td>
                    <td>{item.creative_type || '-'}</td>
                    <td>{item.page}</td>
                    <td>{`₹${item.amount}`}</td>
                    <td> {formatDateWithTime(item.created_date)}</td>

                  </tr>
                )
              })}
            </tbody>) : ((!data?.length && !loading)
              ? <NoDataFound colspan="8" />
              : <TableLoader colspan="8" />
          )
          }
        </table>
      </div>
      <div className='flex justify-end'>
        {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}
      </div>
      <SlDrawer label="Duplicate Records" open={view} onSlAfterHide={() => setView(false)} style={{ '--size': `${window.innerWidth <= 767 ? '100vw' : '50vw' }`}}>
        <div className='overflow-x-auto mb-4'>
          <table className='table-base'>
            <thead>
              <tr>
                <th>Language</th>
                <th>State</th>
                <th>District</th>
                <th>Constituency</th>
                <th>Creative Type</th>
                <th>Page</th>
                <th>Amount</th>
              </tr>
            </thead>
            {(duplicateData?.length) ? (
              <tbody>
                {duplicateData.map((item) => {
                  return (
                    <tr key={item.id} >
                      <th scope='row'>{item.language}</th>
                      <td>{item.state || '-'}</td>
                      <td>{item.district || '-'}</td>
                      <td>{item.constituency}</td>
                      <td>{item.creative_type || '-'}</td>
                      <td>{item.page}</td>
                      <td>{`₹${item.amount}`}</td>
                    </tr>
                  )
                })}
              </tbody>) 
            : ''}
          </table>
        </div>
        <SlButton slot="footer" variant="primary" onClick={() => setView(false)}>
          Close
        </SlButton>
      </SlDrawer>
    </>
  );
  }

export default SalesPriceCardList;
